import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import TitleLayout from '../../kosherTeudot/generic/TitleLayout'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'
import { IProblemLineNew } from '../../../../../modules/API/TeudotProblems/models/problems'
import AcceptIcon from '../../../../../generic/icons/IconLib/CheckIcon'
import AppleIcon from '../../../../../generic/icons/IconLib/AppleIcon'
import CloseIcon from '../../../../../generic/icons/IconLib/XIcon'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon'
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon'
import ShekelIcon from '../../../../../generic/icons/IconLib/ShekelIcon'
import SpeedIcon from '../../../../../generic/icons/IconLib/TruckIcon'
import { getStatusColor, getStatusText, getTextFromDriverStatus, statusListForSelect, useProblemTypeLabel } from '../hooks/useProblemHelpers'
import StatusBadge from './StatusBadge'
import { IApproveProblemData } from '../../../../../modules/API/TeudotProblems/models/requests'
import { SwipeableListItem } from '../../../../../generic/swipe/SwipeableListAdapter'
import SwipeContent from '../../knisot/Components/SwipeContent'
import ProblemQuantityRequest from './ProblemQuantityRequest'
import StatusReturningBadge from '../../drivers/Components/StatusReturningBadge'
import { calculateProblemCost } from '../utils/problemTypeUtils'
import ProblemCostSummary from './ProblemCostSummary'
import { DropdownSelect } from './DropdownSelect'

interface Props extends IProblemLineNew {
  handleApproveProblem?: (data: IApproveProblemData) => void
  isOfficeUser: boolean
  handleOpenDriverStatusModal?: (line: IProblemLineNew) => void
}

const ProblemDetailsItem = (props: Props) => {
  const {
    ProblemType,
    Weight,
    Price,
    Status,
    RemarkApproved,
    RemarkRequested,
    QuantityRequested,
    WeightRequested,
    PriceRequested,
    QuantityApproved,
    Quantity,
    RecID,
    handleApproveProblem,
    DriverStatus,
    isOfficeUser,
    PriceOriginal,
    WeightOriginal,
    QuantityOriginal,
    handleOpenDriverStatusModal,
  } = props
  const [isShowApprove, setIsShowApprove] = useState(false)
  const [isShowReject, setIsShowReject] = useState(false)
  const isDisabled = useMemo(() => {
    return (Status !== 0 && Status !== 3) || !isOfficeUser 
  }, [Status, isOfficeUser])

  //  (ProblemType === 3 && DriverStatus === 0)
  console.log('isDisabled', isDisabled)
  const handleSwipeApprove = () => {
    if(isDisabled) return
    setIsShowApprove(!isShowApprove)
    setIsShowReject(false)
  }
  const handleSwipeReject = () => {
    if(isDisabled) return
    setIsShowReject(!isShowReject)
    setIsShowApprove(false)
  }

  const getProblemTypeLabel = useProblemTypeLabel()

  const handleItemClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const handleApproveProblemClick = () => {
    console.log('isDisabled', isDisabled)

      handleApproveProblem?.({
        PriceApproved: PriceRequested,
        QuantityApproved: QuantityRequested,
        RecID: RecID,
        RemarkApproved: RemarkApproved,
        Status: 1,
        WeightApproved: WeightRequested,
    })
    setIsShowApprove(false)
  }
  const handleRejectProblemClick = () => {
    handleApproveProblem?.({
      PriceApproved: PriceRequested,
      QuantityApproved: QuantityRequested,
      RecID: RecID,
      RemarkApproved: RemarkApproved, 
      Status: 2,
      WeightApproved: WeightRequested,
    })
    setIsShowReject(false)
  }

  const handleStatusChange = (item: {id: number, desc: string}) => {
    console.log('isDisabled', isDisabled)
    if(isDisabled) return
    handleApproveProblem?.({
      PriceApproved: PriceRequested,
      QuantityApproved: QuantityRequested,
      RecID: RecID,
      RemarkApproved: RemarkApproved,
      Status: item.id,
      WeightApproved: WeightRequested,
    })
    setIsShowApprove(false)
  }
  const getProblemCostResult = useMemo(() => {
    const problem = {
      Type: ProblemType,
      Weight: Weight,
      Price: Price,
      Quantity: Quantity,
      WeightRequested: WeightRequested,
      PriceRequested: PriceRequested,
      QuantityRequested: QuantityRequested,
    }
    const originalInfo = {
      Quantity: Status !== 0 ? QuantityOriginal : Quantity,
      Price: Status !== 0 ? PriceOriginal : Price,
      Weight: Status !== 0 ? WeightOriginal : Weight,
    }
    return calculateProblemCost(problem, originalInfo)
  }, [ProblemType, Weight, Price, Quantity, WeightRequested, QuantityRequested, PriceRequested, PriceOriginal, WeightOriginal, QuantityOriginal])
 
  const formedStatusList = useMemo(() => {
    console.log(statusListForSelect)
    return statusListForSelect.filter(item => 
      item.id !== 0 && (ProblemType === 3 && DriverStatus === 0 ? item.id !== 1 : true))
  }, [ProblemType, DriverStatus])
  return (
    <MainWrapper onClick={handleItemClick}>
       <SwipeableListItem
        blockSwipe={!handleApproveProblem || isDisabled}
        swipeLeft={{
          content: <SwipeContent text={'דחה'} isPrimal position='right' />,
          action: () => handleSwipeReject()
        }}
        swipeRight={{
          content: <SwipeContent text={'אישור'} position='left' />,
          action: () => handleSwipeApprove()
        }}
        threshold={0.3}
      >
      <ClickableWrapper onClick={handleApproveProblemClick} $isShow={isShowApprove}>
        <AcceptIcon />
      </ClickableWrapper>
      
      <TitleLayout disableShadow>
     
      {
        !isDisabled && (
          <SelectorWrapper>
            <DropdownSelect<{id: number, desc: string}, 'id', 'desc'>
              items={formedStatusList}
              valueKey="id"          // defaultValue будет сравниваться по user.id
              labelKey="desc"        // в списке и триггере показываем user.name
              defaultValue={Status}       // сразу выберется Bob
              onChange={handleStatusChange}
              placeholder="פתוח"
              isTop={true}
            />

            </SelectorWrapper>
        )
      }
      <StatusBadgeWrapper>
        {isDisabled && (
          <StatusBadge statusColor={getStatusColor(Status)}>
            {getStatusText(Status)}
          </StatusBadge>
        )}
      </StatusBadgeWrapper>
      
        <TitleRow>
          <TitleRowItem   
            name={
              <BadgeLineWrapper>
                {ProblemType === 3 &&
                <StatusReturningBadge
                  status={DriverStatus}
                  onClick={isOfficeUser && handleOpenDriverStatusModal ? (e) => {
                    e.stopPropagation()
                    handleOpenDriverStatusModal(props)
                  } : undefined}
                />
                 } סוג פניה: {getProblemTypeLabel(ProblemType)}
              </BadgeLineWrapper>
              }
            icon={<AppleIcon />}
          />
        </TitleRow>
        <ProblemQuantityRequest
          prblemType={ProblemType}
          requestQuantity={QuantityRequested}
          quantity={Status !== 0 ? QuantityOriginal : Quantity}
          requestWeight={WeightRequested}
          weight={Status !== 0 ? WeightOriginal : Weight}
          requestPrice={PriceRequested}
          price={Status !== 0 ? PriceOriginal : Price}
        />
       
        {
          isOfficeUser && (
            <TitleRow>
              <ProblemCostSummary
                costResult={getProblemCostResult}
               
              />
            </TitleRow>
          )
        }
       
        {RemarkRequested && (
          <TitleRow>
            <TitleRowItem 
              name={`הערה מבוקשת: ${RemarkRequested}`}
              icon={<EditIcon />}
            />
          </TitleRow>
        )}
        {RemarkApproved && (
          <TitleRow>
            <TitleRowItem 
              name={`הערה מאושרת: ${RemarkApproved}`}
              icon={<EditIcon />}
            />
          </TitleRow>
        )}
      </TitleLayout>
      <ClickableWrapper onClick={handleRejectProblemClick} $isShow={isShowReject} $isPrimal>
        <span style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={() => {}}><CloseIcon /></span>
      </ClickableWrapper>
      
      </SwipeableListItem>  
    </MainWrapper>
  )
}

const MainWrapper = styled.div`
  position: relative;
  border-left: 3px solid #80E081;
  padding-left: 0.5em;
  overflow: hidden;
  border-radius: 20px;
  background: #fff;
`
const StatusBadgeWrapper = styled.div`
  position: absolute;
  bottom: 0.2em;
  left: 1em;
`
const SelectorWrapper = styled.div`
  position: absolute;
  bottom: 0.5em;
  left: 1.2em;
  z-index: 4;
`

const ClickableWrapper = styled.div<{ $isShow: boolean, $isPrimal?: boolean }>`
  display: ${props => props.$isShow ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
  width: 4em;
  min-height: 4em;
  color: #ffff;
  background: ${props => props.$isPrimal ? 'tomato' : '#64A19C'};
  padding: 0.5em;

`
const BadgeLineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
`
export default ProblemDetailsItem 